// extracted by mini-css-extract-plugin
module.exports = {"unit":"8px","borderRadius":"4px","error":"login-page__error____180WM","button":"login-page__button____2pCOM"};